import React, { useContext } from 'react'

import useClickOutsideBox from '../hooks/useClickOutsideBox'

import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'
import LEExperienceSummaryCard from '../SummaryCards/LEOffer/LEExperienceSummaryCard'

interface Props {
  offer: App.ExperienceOffer | undefined
  cardRef: React.MutableRefObject<HTMLDivElement | null>
}

function LEOfferCard({
  offer,
  cardRef,
}: Props) {
  const { onDeselectMapItem } = useContext(TripMapContext)

  useClickOutsideBox(cardRef, onDeselectMapItem, { excludeModalClicks: true })

  if (!offer) return null

  if (offer.type === 'experience') {
    return <LEExperienceSummaryCard experience={offer} cardRef={cardRef} onClose={onDeselectMapItem} />
  }

  return null
}

export default LEOfferCard
